<template>
  <div class="level">
    <div class="video_box" v-if="showVideo">
      <video :src="videourl" :poster='videoImg' ref="video" @click="playVideo()" controls autoplay webkit-playsinline='true' playsinline='true'>
        <source :src="videourl">
      </video>
      <div class="bo" v-show='showPlay' @click="playVideo()"></div>
    </div>
    <img :src="imgurl" alt="" class="bgImg">
  </div>
</template>


<script>
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      id: "",
      imgurl: "",
      videourl: "",
      videoImg: "",
      showPlay: true,
      showVideo: false,
      share: "1",
      title: "",
      desc: "",
      shareImg: ""
    };
  },
  created() {
    this.id = this.getQueryValue("id");
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    async getDetails() {
      const res = await this.axios.get(`/contents/detail?id=${this.id}`);
      if (res.code === 1) {
        this.imgurl = res.data.content_image;
        this.share = res.data.share_data;
        if (res.data.type_list == 1) {
          this.showVideo = true;
          this.videourl = res.data.video_file;
          this.videoImg = res.data.image;
          console.log(res);
        }
        if (this.share == 1) {
          this.getShare();
        } else {
          this.title = res.data.share_name;
          this.desc = res.data.share_describe;
          this.shareImg = res.data.share_image;
          this.getShareInfo();
        }
      }
    },
    async getShare() {
      const res = await this.axios.get(`/index/config`);
      if (res.code == 1) {
        this.shareData = res.data;
        this.title = res.data.name;
        this.desc = res.data.content;
        this.shareImg = res.data.image;
        this.getShareInfo();
      }
    },
    playVideo() {
      let video = this.$refs.video;
      video.play();
      this.showPlay = false;
    },
    async getShareInfo() {
      let that = this;
      let url = location.href.split("#")[0];
      const res = await this.axios.get(`/index/share?url=${url}`);
      if (res.code === 1) {
        // const { data } = res.data;
        // console.log(data, "1");
        let appId = res.data.appid;
        let timestamp = res.data.timestamp;
        let nonceStr = res.data.nonceStr;
        let signature = res.data.signature;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，
          appId: appId,
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
          ],
        });
        wx.ready(function () {
          //分享到朋友圈
          wx.onMenuShareTimeline({
            title: that.title, // 分享时的标题
            link: url, // 分享时的链接
            imgUrl: that.shareImg, // 分享时的图标
            success: function () {
              console.log("分享成功");
            },
            cancel: function () {
              console.log("取消分享");
            }
          });
          //分享给朋友
          wx.onMenuShareAppMessage({
            title: that.title,
            desc: that.desc,
            link: url,
            imgUrl: that.shareImg,
            type: "",
            dataUrl: "",
            success: function () {
              console.log("分享成功");
            },
            cancel: function () {
              console.log("取消分享");
            }
          });
        });
      }
    }
  },
  beforeDestroy() {
    let video = this.$refs.video;
    if (video) {
      video.pause();
    }
  }
};
</script>

<style lang="less" scoped>
.level {
  .video_box {
    position: relative;
    video {
      width: 100%;
      display: block;
    }
    .bo {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 0.57rem;
      height: 0.66rem;
      background: url(../assets/img/bo.png) no-repeat center center;
      background-size: 0.56rem;
    }
  }
  .bgImg {
    width: 100%;
    display: block;
  }
}
</style>